import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=776d863e&scoped=true&lang=pug"
import script from "./SubmitButton.vue?vue&type=script&lang=js"
export * from "./SubmitButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776d863e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('776d863e')) {
      api.createRecord('776d863e', component.options)
    } else {
      api.reload('776d863e', component.options)
    }
    module.hot.accept("./SubmitButton.vue?vue&type=template&id=776d863e&scoped=true&lang=pug", function () {
      api.rerender('776d863e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/buttons/SubmitButton.vue"
export default component.exports